import classNames from 'classnames';
import {useTranslations} from 'next-intl';
import {ComponentProps, FC, ReactElement} from 'react';
import styles from './MeinTag.module.css';

interface IProps extends ComponentProps<'span'> {
    className?: string;
    label?: string | ReactElement<any>;
}

export const MeinTag: FC<IProps> = ({className, label}) => {
    const t = useTranslations('global');
    return (
        <span className={classNames(styles.container, className)}>
            {label ? label : t('new')}
        </span>
    );
};
